import React from 'react'
import titledSectionStyle from "../components/css/titledSection.module.scss"

export default function({title, highlightText, children, theme}){
    let themeStyle = "";
    if(theme=="ribbon")
    {
        themeStyle= titledSectionStyle.ribbon;
    }

    return (
            <section className={titledSectionStyle.titledSection}>
                { highlightText ? 
                    <header>
                        <h2>{title}</h2>
                        <span className={titledSectionStyle.calloutHighlightHeader}>{highlightText}</span>
                    </header> 
                    : 
                    <h2 className={themeStyle}>{title}</h2>
                }
                <div className={titledSectionStyle.childcontent}>{children}</div>
            </section>
    )
}